import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';

const Wrapper = styled.div<{ $isDesktop: boolean }>`
  width: 100%;
  border-radius: 12px;
  background-color: ${color(COLOR_VARIANTS.BUTTERCUP10)};
  padding: 16px;
  display: flex;
  flex-direction: ${({ $isDesktop }) => ($isDesktop ? 'row' : 'column')};
  gap: ${({ $isDesktop }) => ($isDesktop ? '4px' : '16px')};
  margin-bottom: ${({ $isDesktop }) => ($isDesktop ? '16px' : '0')};
  align-items: ${({ $isDesktop }) => ($isDesktop ? 'center' : 'stretch')};
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Footer = styled(FlexWrapper)<{ $isDesktop: boolean }>`
  flex: ${({ $isDesktop }) => ($isDesktop ? '1' : 'unset')};
  justify-content: space-between;
  align-items: initial;
`;

const ExampleWrapper = styled(FlexWrapper)`
  gap: 8px;
`;

const LinkGroup = styled(FlexWrapper)`
  gap: 24px;
`;

export default {
  Wrapper,
  Footer,
  ExampleWrapper,
  LinkGroup,
};
